<template>  
  <div class="container-fluid mt-2">

<slot v-if="loading == 0">
  <div class="row">
    <div class="col-12 text-center">
      <h4 style="color: #0E1698">Preparing the Builder</h4>
    </div>
    <div class="col-12 mt-4">
      <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>
    </div>
  </div>
</slot>

<slot v-if="loading == 1">    
    <div class="row">
    </div>

    <div class="row">

      <div class="col-12 col-lg-6 col-xl-4 h-100"><!--  start option section -->
        <div class="row">
          <div class="col-12">
            <h3 class="text-secondary">Optional Items</h3>
          </div>

          <div class="col-12 h-50">
            <div class="card border-top border-bottom border-right-0 border-left-0">
              <div class="card-body " style="max-height:700px; overflow:auto; background-color: #F8F8F8">

                <div v-if="availItems.length > 0" class="border-0">

                  <div v-for="(avail, index) in availItems" class="row mb-1 border-0">
                    <div class="col-12 small"><i @click="addToBuild(index)" class="fa fa-plus mr-1" aria-hidden="true"></i> {{ avail.name }}</div>
                  </div>

                </div>
                <div v-if="stdInc.length < 1" class="text-center mt-5">
                  <h5 class="text-secondary">No Optional Items</h5>
                </div>
              </div>
            </div>          
            
          </div>
        </div>
      </div><!--  end option section -->

      <div class="col-12 col-lg-6 col-xl-5 h-100 px-xl-5"><!--  start build section -->

        <div class="row">
          <div class="col-12">
            <h3 class="text-secondary">Your Build</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-12 border-top border-bottom d-flex justify-content-between">
            <a href="#" @click="switchIncSec(0)">Included in Product</a>
            <a href="#" @click="switchIncSec(1)">Included Options</a>
          </div>
        </div>
        <div class="row">
          <transition name="slide-fade" mode="out-in">
            <div key=1 v-if="incSec == 0" class="col-12">
              <div class="card border-0">
                <div class="card-body" style="max-height:700px; overflow:auto">
                  <ul v-if="stdInc.length > 0" class="list-group border-0">
                    <li v-for="(std, index) in stdInc" class="list-group-item mb-1 p-1 border-0">
                      {{ std.name }}
                    </li>
                  </ul>
                  <div v-if="stdInc.length < 1" class="text-center mt-5">
                    <h5>No included items</h5>
                  </div>
                </div>
              </div>
            </div>

            <div key=2 v-if="incSec == 1" class="col-12">
              <div class="card border-0">
                <div class="card-body" style="max-height:700px; overflow:auto">
                  <div class="list-group pt-1">
                    <div v-for="(opt, index) in optIncs" class="list-group-item mb-2 py-1 px-2">
                      <div class="mb-1"><span v-if="opt.qty > 1">{{ opt.qty }} x </span>{{ opt.name }}</div>
                      <div class="d-flex w-100 justify-content-between">
                        <small class="mb-1">{{ opt.pn }}</small>
                        <small class="text-muted">{{ opt.extprice | currency }}</small>
                        <span>
                          <i @click="removeFromBuild(index)" class="fa fa-trash-o text-danger" aria-hidden="true"></i><span  v-if="opt.qty > 1"> x 1</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="optIncs.length < 1" class="text-center mt-5 text-secondary">
                <div class="card border-0">
                  <div class="card-body" style="max-height:700px; overflow:auto">
                    <h5>You have not added any optional items to the build. Find an item you wish to add in the "Optional Items" list, and click the "<i class="fa fa-plus" aria-hidden="true"></i>" to add it.</h5>
                  </div>
                </div>
              </div>
            </div>
          </transition>

        </div>
      </div><!--  end build section -->
      

      <div class="col-12 col-xl-3 h-100"><!--  start pricing section -->
        <div class="row">
          <div class="col-12">
            <h3 class="text-secondary">Pricing</h3>
          </div>


          <div class="col-12">
            <div class="card border-top border-bottom-0 border-right-0 border-left-0 mb-0">
              <div class="card-body pb-0">
                <div class="row">
                  <div class="col-12">
                    <h5>Base Price</h5>
                  </div>
                  <div class="col-12">
                    {{ prodDetails.part_number}} {{ prodDetails.name}}
                  </div>
                  <div class="col-12 text-right">
                    {{ prodDetails.base_price | currency }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="card border-top border-bottom border-left-0 border-right-0 mb-0">
              <div class="card-body pb-0">
                <div class="row">
                  <div class="col-12">
                    <h5>Optionals Price</h5>
                  </div>
                  <div class="col-12">
                    {{ optIncs.length}} x Optionals
                  </div>
                  <div class="col-12 text-right">
                    {{ optPrice | currency }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="card border-top border-bottom border-left-0 border-right-0">
              <div class="card-body pb-0">
                <div class="row">
                  <div class="col-12">
                    <h5>Subtotal</h5>
                  </div>
                  <div class="col-12 text-right">
                    {{ subTotal | currency }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>

          <div class="col-12">
            <div class="card border-0 mb-5">
              <div class="card-body pb-0">
                <div class="row mb-3">
                  <div class="col-12">
                    <small class="text-muted">Give this build a unique name.</small>
                  </div>
                  <div class="col-12">
                    <input type="text" class="form-control" v-model="build_name" />
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 d-flex justify-content-between align-items-center">
                    <button @click="cancelBuild" class="btn btn-danger">Cancel</button>
                    <button v-if="saveButton == false" class="btn btn-success" @click="submitBuild" :disabled="saveButton">Save Build</button>
                    <div class="d-flex justify-content-start" v-if="saveButton == true" >
                      <spring-spinner :animation-duration="2000" :size="25" color="#0E1698" class=""/>
                      <span class="ml-2" style="color: #0E1698">Saving...</span>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div><!--  end pricing section -->

    </div>
</slot>

  </div><!--  end container-fluid div -->
</template>


<script>
import { SpringSpinner } from 'epic-spinners'
import { ScalingSquaresSpinner } from 'epic-spinners'  
import {store} from '../../stores/product-builder-main-store.js'

/*
prop3 =
  [0] = 1 or 2, 1 for build off product, 2 for off build
  [1] = id of above
*/

export default {
  store,
  props: ['prop1', 'prop2', 'prop3'],
  data: function () {
    return { 
      loading: 0,
      incSec: 1,
      prodDetails: [],
      stdInc: [],
      optIncs: [],
      // optPrice: '',
      availItems: [],
      build_name: '',

      tempDetails: [], // holder if this is a build edit for the previous build info
      prevBuildErrors: [],  // holder for all the errors from previous build
      saveButton: false,
    }
  },
  computed: {
    userBuildList () { return this.$store.state.userBuildList },
    optPrice() {
      var totPrice = 0;
      for (i = 0; i < this.optIncs.length; i++) {

        totPrice = totPrice + parseInt(this.optIncs[i].extprice)
      } 
      return totPrice;
    },
    subTotal() {
      return parseInt(this.prodDetails.base_price) + this.optPrice
    }
  },
  watch: {
    availItems() {
      var _this = this;
      if(_this.availItems.length > 0 && _this.prop3[0] == 2) {
        _this.cyclePreviousBuild(_this.tempDetails.options)
      }
    }
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    getMainView(name, x, y, z) { this.$store.dispatch("getMainView", { name: name, prop1: x, prop2: y, prop3: z })  },

    onLoad() {
      var _this = this;
      _this.loading = 0;
      if(_this.prop3[0] == 1) {
        _this.getProductInformation(_this.prop3[1]);
        
      }
      if(_this.prop3[0] == 2) {
        _this.getBuildInformation(_this.prop3[1]);
      }

    },

    getProductInformation(x) {
      var _this = this;

      axios.get('/builder/utility/product/getproductforbuilder/' + x)
        .then(function (response) {
            _this.prodDetails = response.data.data;
            _this.stdInc = _this.prodDetails.includes;
            _this.availItems = _this.prodDetails.items;
            _this.loading = 1;
          });

    },


    getBuildInformation(x) {
      var _this = this;
      axios.get('/builder/utility/build/getspecificbuild/' + x)
        .then(function (response) {
            _this.tempDetails = response.data.data;
            _this.getProductInformation(_this.tempDetails.product.id);
          })
        .catch(function(error){
          var errors = error.response.data.errors;
          _this.errorDisplay(errors);
        });

        
    },

    cyclePreviousBuild(y){
      var _this = this;
      // y should be the array of optional includes from previous build
      var len = y.length;
      var errors = new Array;


      for (var i = 0; i < len; i++) { // cycle through each of the optional additions
        var item = y[i];
        // checks to make sure its still in the available items array
        var check = _this.availItems.findIndex(x => x.id === item.item_id);
        if(check == -1) {
          // if the item doesnt exist in avail then record it, and splice it
          var msg = item.item_name+", part number "+item.item_pn+" is no longer among the items available to add to this product.";
          _this.prevBuildErrors.push(msg);
          y.splice(i,1)
        }
      }

      // var len = y.length;
      // for (var i = 0; i < len; i++) { // cycle through each of the optional additions
      //   var item = y[i];
      //   // get the item frm avail
      //   var check = _this.availItems.findIndex(x => x.id === item.item_id);

      //   if(check == -1) {
      //     // if the item doesnt exist in avail then record it, and splice it
      //     var msg = item.item_name+", part number "+item.item_pn+" is no longer among the items available to add to this product.";
      //     _this.prevBuildErrors.push(msg);
      //     y.splice(i,1)
      //   }
      // }

      var len = y.length;
      for (var i = 0; i < len; i++) { // cycle through each of the optional additions
        var item = y[i];
        // get the item frm avail
        var check = _this.availItems.findIndex(x => x.id === item.item_id);
        var avail = _this.availItems[check];
        var extPriceSet = item.qty * avail.price ;

        _this.optIncs.push({
            id: avail.id,
            pn: avail.part_number,
            name: avail.name,
            price: avail.price,
            extprice: extPriceSet,
            qty: item.qty,
        })
      }

    },

    switchIncSec(x) {
      var _this = this;
      if(_this.incSec == x) {
        return false;
      } else {
        _this.incSec = x;
      }
      
    },

    addToBuild(index) {
      var _this = this;
      var errors = new Array;
      var item = _this.availItems[index];

      // check qty allow
      var qtyAllow = item.qty_allow;
      var check = _this.optIncs.findIndex(x => x.id === item.id);
      if(qtyAllow ==  1 && check != -1) {
        errors.push("A quantity greater than one is not allowed for this item.")
      }
      // check exclude allow, if yes, cycle through and add an error for each that exists
      if(item.exclude_allow == 0) {
        for (var i = 0; i < item.exclude_of.length ; i++) {
            var acheck = _this.optIncs.findIndex(x => x.id === item.exclude_of[i]);
            if(acheck != -1) {
              errors.push('The item you added is not allowed on the same build as '+ _this.optIncs[acheck].name)
            }
        }
      }

      if(errors.length > 0){
        _this.addErrorDisplay(errors);
        return false;
      }

      if(check < 0) {
        _this.optIncs.push({
            id: _this.availItems[index].id,
            pn: _this.availItems[index].part_number,
            name: _this.availItems[index].name,
            price: _this.availItems[index].price,
            extprice: _this.availItems[index].price,
            qty: 1,
        })
      } else {
        if(item.qty_allow == 0 && _this.optIncs[check].qty < item.max_allow){
          var newQty = _this.optIncs[check].qty + item.interval_add;
          if(newQty > item.max_allow) {
            newQty = item.max_allow
          }
          var newPrice = newQty * item.price;
          Vue.set(_this.optIncs[check], 'qty', newQty)
          Vue.set(_this.optIncs[check], 'extprice', newPrice)
        }


      }

      
    },
    removeFromBuild(index) {
      var _this = this;
      if(_this.optIncs[index].qty > 1) {
        var newQty = _this.optIncs[index].qty - 1;
        var newPrice = newQty * _this.optIncs[index].price;
        Vue.set(_this.optIncs[index], 'qty', newQty)
        Vue.set(_this.optIncs[index], 'extprice', newPrice)
      } else {
        _this.optIncs.splice(index, 1);
      }
      
    },
    submitBuild() {
      var _this = this;
      _this.saveButton = true;
      var valErrors = [];
      if(_this.build_name == '' || _this.build_name == null) { 
        valErrors.push("A build name is required.") } 
      else {

        // this is where the check for uniqueness should be
        var len = _this.userBuildList.length;
        for (var i = 0; i < len; i++) { // cycle through each of the user's builds
          if(_this.build_name == _this.userBuildList[i].build_name) {
            valErrors.push("A unique build name is required, your entry has already been used.")
          }
        }  
      }
      
      if(valErrors.length > 0) { _this.errorDisplay(valErrors); _this.saveButton = false; return false; }

      axios.post( '/builder/utility/build/storebuild', {
        prod_id: _this.prodDetails.id,
        build_name: _this.build_name,
        base_price: _this.prodDetails.base_price,
        opt_price: _this.optPrice,
        tot_price: _this.subTotal,
        opts: _this.optIncs,
      })
      .then(function(response){
        var msg = response.data.msg;
        _this.$toastr.remove()
        _this.saveButton = false;
        _this.$toastr.success(msg, 'Success!', {timeOut: 5000});
        _this.$emit('onSComplete', ['product-builder']);
      })
      .catch(function(error){
        _this.$toastr.remove()
        _this.saveButton = false;
        var errors = error.response.data.errors;
        _this.errorDisplay(errors);
      });

    },

    cancelBuild(){
      var _this = this;
      _this.$swal.fire({
        title: 'Are you sure?',
        text: "Any work you have done on this build will not be saved.",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Cancel this build',
        cancelButtonText: 'Continue working',
        cancelButtonColor: '#3085d6',
      }).then((result) => {
        if (result.value) {
          _this.$emit('onUComplete', [ 'product-builder' ])
        }
      })
    },
    errorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>Please fix the following errors</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },   

    addErrorDisplay(valErrors) {
      var _this = this;
      var errors = valErrors;
      var errorsHTML = '<div class="alert alert-danger text-left"><strong>The following problems have been identified while trying to add this item:</strong><ul>';
      $.each(errors, function(key, value){ errorsHTML += '<li>' + value + '</li>' });
      errorsHTML += '</ul></div>';
      _this.$swal({ type: 'error', title: 'Problem!', html: errorsHTML, });
    },   
  },    
  components:{
    SpringSpinner,
    ScalingSquaresSpinner,
  },
  filters: {

  }
}
</script>
